<a href="javascript:;" (click)="openModal(template)" >
  Report Bug   
</a>

<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Report a Bug</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div id='toast-container'></div>
  <div class="modal-body">
    <form [formGroup]="bugForm" (ngSubmit)="submitBug()">
      <div class="card-body">
        <div *ngIf=bugForm class="row">
          <div class="col-md-12 mb-3">
            <label for="notes">Please select a category for the bug you are experincing</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text"> Type of Bug </span>
              </div>
              <select class="form-control" formControlName="bugType">
                <option *ngFor="let bug of bugTypes" [value]="bug.bugType">{{bug.bugType}}</option>
              </select>
            </div>
          </div>
          <div *ngIf="bugForm.value.bugType" class="col-md-12 mb-3">
              <div class="form-group">
                  <label for="notes">Please detail the bug here. Include what you were trying to do at the time of the bug and the results you experienced</label>
                  <textarea class="form-control" formControlName="bugDetails" rows="8" 
                      placeholder="Add bug details here."></textarea>
                </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">

    <button (click)="closeModal()" class="btn btn-secondary">
       Cancel
    </button>
    <button (click)="submitBug()" [ngClass]="bugForm.valid ? 'btn-primary' : 'btn-secondary'" class="btn ">
      Confirm
    </button>
  </div>


  
</ng-template>



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-bugreporting/app-bugreporting.component.html